import { BcAlert } from '@britishcouncil/react-solas-ors3';

export const PaymentNotFound = () => (
  <BcAlert title="Not found" type="danger">
    <p>Payment not found. Please try again later.</p>
  </BcAlert>
);
